;(function () {
  angular
    .module('contrast.beta-rules')
    .factory('csBetaRulesService', csBetaRulesService)

  function csBetaRulesService(AGENT_LANGUAGE) {
    'ngInject'

    var csBetaRules = [
      {
        rule: 'csrf',
        languages: [
          AGENT_LANGUAGE.DOTNET[0],
          AGENT_LANGUAGE.JAVA[0],
          AGENT_LANGUAGE.NODE[0],
          AGENT_LANGUAGE.RUBY[0],
          AGENT_LANGUAGE.PYTHON[0]
        ]
      },
      {
        rule: 'nosql-injection',
        languages: [
          AGENT_LANGUAGE.NODE[0],
          AGENT_LANGUAGE.RUBY[0],
          AGENT_LANGUAGE.PYTHON[0]
        ]
      },
      {
        rule: 'unsafe-file-upload',
        languages: [
          AGENT_LANGUAGE.NODE[0],
          AGENT_LANGUAGE.RUBY[0],
          AGENT_LANGUAGE.JAVA[0],
          AGENT_LANGUAGE.DOTNET[0],
          AGENT_LANGUAGE.DOTNET_CORE[0],
          AGENT_LANGUAGE.PYTHON[0]
        ]
      },
      {
        rule: 'ognl-injection',
        languages: [AGENT_LANGUAGE.JAVA[0]]
      },
      {
        rule: 'padding-oracle',
        languages: [AGENT_LANGUAGE.JAVA[0]]
      },
      {
        rule: 'redos',
        languages: [AGENT_LANGUAGE.JAVA[0]]
      },
      {
        rule: 'ssjs-injection',
        languages: [AGENT_LANGUAGE.NODE[0]]
      },
      {
        rule: 'ssrf',
        languages: [AGENT_LANGUAGE.RUBY[0]]
      },
      {
        rule: 'untrusted-deserialization',
        languages: [AGENT_LANGUAGE.RUBY[0]]
      },
      {
        rule: 'zip-file-overwrite',
        languages: [AGENT_LANGUAGE.JAVA[0]]
      },
      {
        rule: 'signature-tampering',
        languages: [AGENT_LANGUAGE.JAVA[0]]
      }
    ]

    var csNewRules = []

    var service = {
      getBetaRule: getBetaRule,
      getNewRule: getNewRule
    }

    return service

    function getBetaRule(ruleUuid, language) {
      if (language) {
        return _.find(csBetaRules, function (betaRule) {
          return (
            betaRule.rule === ruleUuid &&
            _.includes(betaRule.languages, language)
          )
        })
      }
      return _.find(csBetaRules, { rule: ruleUuid })
    }

    function getNewRule(ruleUuid, language) {
      if (language) {
        return _.find(csNewRules, function (newRule) {
          return (
            newRule.rule === ruleUuid && _.includes(newRule.languages, language)
          )
        })
      }
      return _.find(csNewRules, { rule: ruleUuid })
    }
  }
})()
